export const NetworkConstants = {
    COLLECTION_HUNTING_DISTRICT: "HuntingDistrict",
    COLLECTION_USER: "User",
    FIELD_CONTEXT_ID: "contextId",
    FIELD_HUNTINGDISTRICT_ID: "huntingDistrictId",
    COLLECTION_POINT_OF_INTEREST: "PointOfInterest",
    DOCUMENT_IDENTIFIER: "identifier",
    DOCUMENT_CONTEXT_ID: "contextId",
    DOCUMENT_HUNTING_DISTRICT_ID: "huntingDistrictId",
    COLLECTION_CONTEXT: "Context",
    COLLECTION_SETTINGS: "Settings",
    COLLECTION_MODULES: "Modules",
    SETTING_GR_LOCATION: "gameRecordLocations",
    SETTING_GR_STATUS: "gameRecordStatus",
    SETTING_GEO_TYPE: "geoObjectTypes",
    SETTING_GEO_LINE_TYPES: "geoObjectLineTypes",
    SETTING_GEO_POLYGON_TYPES: "geoObjectPolygonTypes",
    SETTING_GEO_CATEGORY: "geoObjectCategory",
    SETTING_COLLECTIVE_SPECIES: "collectiveSpecies",
    SETTING_HUNTING_METHODS: "huntingMethods",
    SETTING_LAB_SAMPLE_LOCATION: "laboratorySampleLocation",
    SETTING_LAB_SAMPLE_STATUS: "laboratorySampleStatus",
    SETTING_LAB_SAMPLE_TYPE: "laboratorySampleType",
    SETTING_GR_MEAT_QUALITY: "meatQualities",
    SETTING_GR_SHOT_QUALITY: "shotQualities",
    SETTING_UTILIZATION_OPTION: "utilizationOptions",
    SETTING_TROPY_TYPE: "trophyType",
    SETTING_SPECIES: "species",
    SETTING_READOUT_GROUPS: "reportGroups", //"readoutGroups",
    SETTING_EVENT_INVITATION_SITE_REFERRAL: "eventInvitationSiteReferral",
    SETTING_USER_ROLES: "userRoles",
    COLLECTION_USER_GROUP: "UserGroup",
    COLLECTION_GAMERECORD: "GameRecord",
    COLLECTION_PERSON: "Person",
    COLLECTION_GAME_COLLECT_STATION: "GameCollectStation",
    COLLECTION_DIGATAG: "Digatag",
    COLLECTION_CONTEXT_MEMBERSHIP: "ContextMembership",
    COLLECTION_POI: "PointOfInterest",
    COLLECTION_EVENT: "Event",
    COLLECTION_DOG: "Dog",
    COLLECTION_LABSAMPLE: "LaboratorySample",
    COLLECTION_TROPHY: "Trophy",
    COLLECTION_TRANSACTION_LOG: "TransactionLog",
    COLLECTION_OUTLINE: "Outline",
    SETTING_GEO_USAGE_STATUS: "geoObjectUsageStates",
    COLLECTION_EVENT_INV: "EventInvitation",
    COLLECTION_EVENT_TRANSACTION: "EventInvitationTransaction",
    COLLECTION_DISTRICT_REPORTING: "DistrictReporting",
    COLLECTION_LIFE_SIGN: "LifeSign",
    COLLECTION_WORK_ORDER: "WorkOrder",
    COLLECTION_GLOBAL_SETTINGS:"GlobalSettings",
    COLLECTION_COUNTRIES:"Countries",
    COLLECTION_STATES:"States",
    COLLECTION_VETERINARY_AUTHORITY:"VeterinaryAuthority",
    COLLECTION_HUNTING_AUTHORITY:"HuntingAuthority",
    COLLECTION_DATA:"Data",
    MODULES_DWM_ADIS:"diwima-adis",
    COLLECTION_SIGHTING: "Sighting",
    SUBCOLLECTION_IMAGE: "Image",
    COLLECTION_CTX_SETTINGS: "Context/Settings",
    ROUTE_CTX_SETTINGS: "contextsettings"
   }